/* eslint-disable react/prop-types */
import { memo } from 'react';
import { useMediaQuery, Avatar as AvatarMaterial } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import './Avatar.css';

function Avatar({ userNameLink, isLive, avatarImage }) {
  const theme = useTheme();
  const profileStreamEnable = process.env.REACT_APP_VIEW_PROFILE_STREAM;

  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div
      style={{ marginRight: `${isMobile ? '14px' : '18px'}` }}
    >
      <a href={userNameLink}>
        {isLive === 1 && profileStreamEnable === 'true' && (
          <div>
            {
              isExtraSmall
                ? (
                  <div>
                    <AvatarMaterial
                      className='profile-avatar-live-border'
                      style={{
                        height: '45px',
                        width: '45px',
                      }}
                      src={avatarImage}
                    />
                    <span
                      style={{
                        width: 45, marginTop: -10, fontSize: 10, borderRadius: '15px', borderStyle: 'solid', borderColor: '#fff', position: 'absolute', zIndex: 4, backgroundColor: '#fb2861', alignItems: 'center', justifyContent: 'center', display: 'flex',
                      }}
                    >
                      LIVE
                    </span>
                  </div>
                )
                : (
                  <div>
                    <AvatarMaterial
                      className='profile-avatar-live-border'
                      style={{
                        height: '80px',
                        width: '80px',
                      }}
                      src={avatarImage}
                    />
                    <span style={{
                      width: 80, marginTop: -15, fontSize: 14, borderRadius: '15px', borderStyle: 'solid', borderColor: '#fff', position: 'absolute', zIndex: 4, backgroundColor: '#fb2861', alignItems: 'center', justifyContent: 'center', display: 'flex',
                    }}
                    >
                      LIVE
                    </span>
                  </div>
                )
            }
          </div>
        )}
        {isLive !== 1 && (
          <div>
            {
              isExtraSmall
                ? (
                  <div>
                    <AvatarMaterial
                      src={avatarImage}
                      style={{
                        height: '45px',
                        width: '45px',
                      }}
                    />
                  </div>
                )
                : (
                  <div>
                    <AvatarMaterial
                      src={avatarImage}
                      style={{
                        height: '80px',
                        width: '80px',
                      }}
                    />
                  </div>
                )
            }
          </div>
        )}
      </a>
    </div>
  );
}

export default memo(Avatar);
